<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active.sync="isFetchingSavedInfo"
      :can-cancel="false"
    ></b-loading>
    <div class="level">
      <div class="level-left">
        <h4 class="title is-4">{{ createOrUpdate }}</h4>
        &nbsp;
      </div>
      <div class="level-right">
        <input
          type="text"
          class="input is-small"
          style="text-align: right"
          placeholder="AUTOGENERATED P.O #"
          v-model="poNumber"
          disabled
        />
      </div>
    </div>
    <hr />
    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <label class="label is-small">P.O Request #</label>
          <div class="control">
            <b-autocomplete
              id="searchPoRequestNumber"
              v-model="poRequestNumber"
              size="is-small"
              :data="poRequestNumbers"
              placeholder="Search approved P.O Request #"
              @select="option => (selectedPoRequestNumber = option)"
              @input="searchPoRequestNumbers"
              :loading="isFetchingPoRequestNumber"
            >
              <template slot="empty">
                <span v-if="isFetchingPoRequestNumber">Please wait...</span>
                <span v-if="poRequestNumbers.length === 0"
                  >No results found</span
                >
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div>
      <div class="column is-3">
        <div class="field">
          <label class="label is-small">Supplier</label>
          <div class="control">
            <b-autocomplete
              id="searchSupplier"
              v-model="supplierName"
              size="is-small"
              :data="suppliers"
              placeholder="Search suppliers"
              @select="option => (selectedSupplier = option)"
              @input="searchSuppliers"
              :loading="isFetchingSuppliers"
            >
              <template slot="empty">
                <span v-if="isFetchingSuppliers">Please wait...</span>
                <span v-if="suppliers.length === 0">No results found</span>
              </template>
            </b-autocomplete>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small"
            >Client<span
              v-if="isFetchingClientAndClientPo"
              style="margin-left:5px;font-style: italic"
              >Fetching...</span
            ></label
          >
          <input
            type="text"
            disabled
            class="input is-small"
            placeholder="Client Name"
            v-model="clientAndClientPo.client"
          />
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small"
            >Client P.O #
            <span
              v-if="isFetchingClientAndClientPo"
              style="margin-left:5px;font-style: italic"
              >Fetching...</span
            ></label
          >
          <input
            type="text"
            disabled
            class="input is-small"
            placeholder="Client P.O"
            v-model="clientAndClientPo.po"
          />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <label class="label is-small"
            >Email (Will automatically send to these emails)</label
          >
          <div class="control">
            <textarea
              type="text"
              class="input is-small"
              v-model="purchaseOrder.emails"
              style="height: 80px"
              placeholder="Enter email(s) here"
              disabled
            />
          </div>
        </div>
      </div>
      <div class="column is-1">
        <div class="field">
          <label class="label is-small">Status</label>
          <div class="select is-small">
            <select v-model="purchaseOrder.poStatus">
              <option value="0">OPEN</option>
              <option value="1">CLOSED</option>
              <option value="2">CANCELLED</option>
              <option value="3">HOLD</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">P.O date</label>
          <div class="control">
            <input
              type="date"
              class="input is-small"
              v-model="purchaseOrder.poDate"
            />
          </div>
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Mailing address</label>
          <textarea
            style="height: 50px"
            type="text"
            class="input is-small"
            v-model="purchaseOrder.mailingAddress"
            placeholder="Enter mailing address"
          />
        </div>
      </div>
      <div class="column is-2">
        <div class="field">
          <label class="label is-small">Shipping address</label>
          <textarea
            style="height: 50px"
            type="text"
            class="input is-small"
            v-model="purchaseOrder.shippingAddress"
            placeholder="Enter shipping address"
          />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <b-table
          :data="poRequestProducts"
          :loading="isLoadingTable"
          :columns="columns"
          :checked-rows.sync="checkedRows"
          checkable
          class="table-column-content-is-small"
        >
          <template slot="row-content" slot-scope="{ item }">
            <b-table-column class="table-column-content-is-small">
              {{ item.row.isReceived }}
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
    <div class="notification">
      <div class="level">
        <div class="level-left"></div>
        <div class="level-right">
          <div class="field">
            <div class="control">
              <label class="label is-small">Total</label>
              <div class="control">
                <h4 class="title is-4">{{ totalAmount | formatNumber }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left"></div>
      <div class="level-right">
        <button
          v-show="hasAdminSalesOrSalesPoStaffPriv"
          :class="buttonSave"
          @click="saveAndSend(true)"
        >
          Save
        </button>
        &nbsp;
        <router-link
          :to="{
            name: 'List of Purchase Order',
            params: { pageSize: 10 }
          }"
          class="button is-small"
          >View list</router-link
        >&nbsp;
        <button class="button is-small" @click="goBack">Go back</button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
//import Loading from "vue-loading-overlay";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import AuthService from "../../_services/auth";
Vue.filter("formatNumber", function(value) {
  if (!value) return 0;
  return numeral(value).format("0,0.00"); // displaying other groupings/separators is possible, look at the docs
});
const appToast = new AppToast();
const appButton = new AppButton();
const authService = new AuthService();
export default {
  components: {
    // Loading,
  },
  created() {
    const purchaseOrderId = this.$route.params.purchaseOrderId;
    if (purchaseOrderId) {
      this.getPoById(purchaseOrderId);
    } else {
      // CREATE Mode
      if (process.env.VUE_APP_ANOTHER_VARIABLE === "ANSI") {
        this.purchaseOrder.shippingAddress =
          "Any Network Systems, Inc. 300 JP Rizal St. Makati City 1204 PH";
      } else {
        this.purchaseOrder.shippingAddress =
          "Adaptive Nets, Inc. 300 JP Rizal St. Makati City 1204 PH";
      }
      this.getCurrentDateFromServer();
    }
  },
  data: () => ({
    createOrUpdate: "Create ",
    // buttons
    buttonDelete: appButton.isLoadingDanger(false),
    buttonSave: appButton.isLoadingSuccess(false),
    buttonSaveAndSend: appButton.isLoadingSuccess(false),
    buttonDownloadPoRequest: appButton.isLoadingDefault(false),
    hasAdminSalesOrSalesAccountingStaffPriv: authService.hasAdminSalesOrSalesAccountingStaffPriv(),
    hasAdminSalesOrSalesPoStaffPriv: authService.hasAdminSalesOrSalesPoStaffPriv(),
    poNumber: "",
    isFetchingSavedInfo: false,
    purchaseOrder: {
      emails:
        "gladys@anynetworksystems.com, roel@anynetworksystems.com, george@anynetworksystems.com, jeannette@anynetworksystems.com, rose@anynetworksystems.com",
      poStatus: 0,
      mailingAddress: "",
      shippingAddress: "",
      poDate: null,
      details: []
    },
    // search po request
    poRequestNumber: "",
    poRequestNumbers: [],
    selectedPoRequestNumber: 0,
    selectedPoRequestNumberId: 0,
    selectedPoRequestNumberForEdit: {},
    isFetchingPoRequestNumber: false,
    // search supplier
    supplierName: "",
    suppliers: [],
    selectedSupplier: 0,
    selectedSupplierId: 0,
    selectedSupplierForEdit: {},
    isFetchingSuppliers: false,
    totalAmount: 0,
    isLoadingTable: false,
    checkedRows: [],
    columns: [
      {
        field: "product",
        label: "Product"
      },
      {
        field: "desc",
        label: "Description"
      },
      {
        field: "qty",
        label: "Quantity"
      },
      {
        field: "price",
        label: "Price"
      },
      {
        field: "amount",
        label: "Amount"
      }
    ],
    poRequestProducts: [],
    isFetchingClientAndClientPo: false,
    clientAndClientPo: {
      client: "",
      po: ""
    }
  }),
  methods: {
    saveAndSend(isSend) {
      if (!this.purchaseOrder.poRequestId) {
        if (!this.selectedPoRequestNumber.id) {
          appToast.danger(
            "Please select a valid P.O request # or consider reselecting the P.O request #"
          );
          return false;
        }
      }
      if (!this.purchaseOrder.supplierId) {
        if (!this.selectedSupplier.id) {
          appToast.danger(
            "Please select a valid supplier under the selected P.O request #."
          );
          return false;
        }
      }
      if (!this.purchaseOrder.poDate) {
        appToast.danger("P.O date is invalid.");
        return false;
      }
      if (this.poRequestProducts.length === 0) {
        appToast.danger("P.O Detail is empty.");
        return false;
      }
      if (this.totalAmount <= 0) {
        appToast.danger("Total must have a valid value.");
        return false;
      }

      if (!this.purchaseOrder.poRequestId) {
        if (this.selectedPoRequestNumber.id) {
          this.purchaseOrder.poRequestId = this.selectedPoRequestNumber.id; // from select
        } else {
          this.purchaseOrder.poRequestId = this.selectedPoRequestNumberId; // from get
        }
      } else {
        // if new selection
        if (
          this.purchaseOrder.poRequestId !== this.selectedPoRequestNumber.id
        ) {
          if (this.selectedPoRequestNumber.id) {
            this.purchaseOrder.poRequestId = this.selectedPoRequestNumber.id;
          } else {
            this.purchaseOrder.poRequestId = this.selectedPoRequestNumberId; // from get
          }
        }
      }
      if (!this.purchaseOrder.supplierId) {
        if (this.selectedSupplier.id) {
          this.purchaseOrder.supplierId = this.selectedSupplier.id;
        } else {
          this.purchaseOrder.supplierId = this.selectedSupplierId;
        }
      } else {
        // new selection
        if (this.purchaseOrder.supplierId !== this.selectedSupplier.id) {
          if (this.selectedSupplier.id) {
            this.purchaseOrder.supplierId = this.selectedSupplier.id;
          } else {
            this.purchaseOrder.supplierId = this.selectedSupplierId;
          }
        }
      }

      // clear po details
      this.purchaseOrder.details = [];
      this.checkedRows.forEach(d => {
        this.purchaseOrder.details = [
          ...this.purchaseOrder.details,
          {
            poRequestDetailId: d.poRequestDetailId
          }
        ];
      });
      this.buttonSave = appButton.isLoadingSuccess(true);
      // CREATE Mode
      if (!this.purchaseOrder.purchaseOrderId) {
        axios
          .post(`api/purchaseorders/`, this.purchaseOrder)
          .then(response => {
            appToast.success(response.data.message);
            this.$router.push({
              name: "List of Purchase Order",
              params: { pageSize: 10 }
            });
            if (isSend) {
              this.sendPurchaseOrder(response.data.poId);
            }
          })
          .catch(error => {
            console.log(error);
            appToast.danger(error.response.data);
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false);
          });
      } else {
        axios
          .put(
            `api/purchaseorders/${this.purchaseOrder.purchaseOrderId}`,
            this.purchaseOrder
          )
          .then(response => {
            appToast.success(response.data);
            this.$router.push({
              name: "List of Purchase Order",
              params: { pageSize: 10 }
            });
            if (isSend) {
              //this.sendPoRequest(response.data.id);
            }
          })
          .catch(error => {
            console.log(error);
            appToast.danger(error.response.data);
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false);
          });
      }
    },
    sendPurchaseOrder(poId) {
      if (poId) {
        this.buttonSaveAndSend = appButton.isLoadingSuccess(true);
        axios
          .post(`downloadables/purchaseorder?id=${poId}&isSent=true`)
          .then(response => {
            appToast.success(response.data);
          })
          .catch(error => console.log(error))
          .then(
            () => (this.buttonSaveAndSend = appButton.isLoadingSuccess(false))
          );
      }
    },
    updateStatus() {
      this.buttonSave = appButton.isLoadingSuccess(true);
      if (this.hasAdminSalesOrSalesAccountingStaffPriv) {
        axios
          .put(
            `api/purchaseorders/update-status/${
              this.purchaseOrder.purchaseOrderId
            }`
          )
          .then(response => {
            appToast.success(response.data);
            this.$router.push({
              name: "List of Purchase Order",
              params: { pageSize: 10 }
            });
          })
          .catch(error => {
            console.log(error);
            appToast.danger(error.response.data);
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false);
          });
      }
    },
    getPoById(id) {
      this.isFetchingSavedInfo = true;
      this.createOrUpdate = "Edit";
      axios
        .get(`api/purchaseorders/${id}`)
        .then(response => {
          console.log(response.data);
          this.getClientAndClientPo(response.data.poRequestId);

          response.data.poRequestProductsForPo.forEach(d => {
            d.price = numeral(d.price).format("0,0.00");
            d.amount = numeral(d.amount).format("0,0.00");
          });

          response.data.poRequestProductsForPo.forEach(d => {
            response.data.details.forEach(e => {
              if (e.poRequestDetailId === d.poRequestDetailId) {
                this.poRequestProducts = [
                  ...this.poRequestProducts,
                  {
                    amount: d.amount,
                    desc: d.desc,
                    poRequestDetailId: d.poRequestDetailId,
                    price: d.price,
                    product: d.product,
                    qty: d.qty,
                    isReceived: e.isReceived,
                    receivedDate: e.receivedDate
                  }
                ];
              }
            });
          });
          this.checkedRows = response.data.details.map(
            ({ poRequestDetailId }) =>
              this.poRequestProducts.find(
                obj => obj.poRequestDetailId === poRequestDetailId
              )
          );
          this.purchaseOrder = response.data;
          this.purchaseOrder.poDate = moment(this.purchaseOrder.poDate).format(
            "YYYY-MM-DD"
          );

          this.poRequestNumber = this.purchaseOrder.poRequest;
          this.selectedPoRequestNumberId = this.purchaseOrder.poRequestId;
          this.supplierName = this.purchaseOrder.supplier;
          this.selectedSupplierId = this.purchaseOrder.supplierId;
          this.poNumber = this.purchaseOrder.poNum;
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    getClientAndClientPo(poRequestId) {
      if (poRequestId) {
        this.isFetchingClientAndClientPo = true;
        axios
          .get(
            `api/porequests/client-and-client-po-by-porequest/${poRequestId}`
          )
          .then(response => {
            this.clientAndClientPo = {
              client: response.data.client,
              po: response.data.clientPo
            };
          })
          .catch(error => console.log(error))
          .then(() => {
            this.isFetchingClientAndClientPo = false;
          });
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    getCurrentDateFromServer() {
      this.isFetchingSavedInfo = true;
      axios
        .get(`api/settings/current-date`)
        .then(response => {
          this.purchaseOrder.poDate = moment(response.data).format(
            "YYYY-MM-DD"
          );
        })
        .catch(error => console.log(error))
        .then(() => {
          this.isFetchingSavedInfo = false;
        });
    },
    searchPoRequestNumbers() {
      if (this.poRequestNumber) {
        // authService.isLoggedIn() // check login
        axios
          .get(`api/searchqueries/porequests-by-number/${this.poRequestNumber}`)
          .then(response => {
            this.poRequestNumbers = response.data;
          })
          .catch(error => console.log(error));
      }
    },
    searchSuppliers() {
      let poRequestId = 0;
      if (this.selectedPoRequestNumber.id) {
        poRequestId = this.selectedPoRequestNumber.id;
      } else {
        poRequestId = this.selectedPoRequestNumberId;
      }

      axios
        .get(
          `api/searchqueries/supplier-by-porequest/${
            this.supplierName
          }/${poRequestId}`
        )
        .then(response => {
          this.suppliers = response.data;
        })
        .catch(error => console.log(error));
    },
    getPoRequestProductBySupplier() {
      let poRequestId = 0;
      let supplierId = 0;
      if (this.selectedPoRequestNumber.id) {
        poRequestId = this.selectedPoRequestNumber.id;
      } else {
        poRequestId = this.selectedPoRequestNumberId;
      }
      if (this.selectedSupplier.id) {
        supplierId = this.selectedSupplier.id;
      } else {
        supplierId = this.selectedSupplierId;
      }
      if (poRequestId && supplierId) {
        this.isLoadingTable = true;
        axios
          .get(
            `api/purchaseorders/po-request-product-by-supplier/${poRequestId}/${supplierId}`
          )
          .then(response => {
            response.data.forEach(d => {
              d.price = numeral(d.price).format("0,0.00");
              d.amount = numeral(d.amount).format("0,0.00");
            });
            this.poRequestProducts = response.data;
            this.computeTotal();
          })
          .catch(error => {
            if (error.response) {
              appToast.danger(error.response.data);
            }
            console.log(error);
          })
          .finally(() => {
            this.isLoadingTable = false;
            this.checkedRows = [];
          });
      }
    },
    computeTotal() {
      this.totalAmount = 0;
      if (this.checkedRows.length > 0) {
        this.checkedRows.forEach(d => {
          this.totalAmount += numeral(d.amount)._value;
        });
      } else {
        this.totalAmount = 0;
      }
    },
    clearSupplierData() {
      this.supplierName = "";
      this.selectedSupplier = "";
      this.selectedSupplierForEdit.id = null;
      this.purchaseOrder.supplierId = 0;
    }
  },
  watch: {
    poRequestNumber() {
      if (!this.poRequestNumber) {
        this.clearSupplierData();
      }
    },
    selectedPoRequestNumber() {
      if (!this.selectedPoRequestNumber) {
        this.clearSupplierData();
        this.clientAndClientPo = {
          client: "",
          po: ""
        };
      } else {
        this.getClientAndClientPo(this.selectedPoRequestNumber.id);
      }
    },
    selectedSupplier() {
      if (this.selectedSupplier.id) {
        this.getPoRequestProductBySupplier();
      }
    },
    checkedRows() {
      this.computeTotal();
    }
  }
};
</script>
